const analytics = () => ({
  logEvent: async () => undefined,
  logScreenView: async () => undefined,
  getAppInstanceId: async () => null
});

export default analytics;
